<div *ngIf="showPanel" class="wms-help-panel" [ngClass]="{'widget-help': isWidgetProp , 'property-help': !isWidgetProp }">
    <div class="heading">
        <div class="title">{{locale["LABEL_WIDGET_" + helpPanel.name.toUpperCase()] || locale["LABEL_PROPERTY_" + helpPanel.name.toUpperCase()] || locale[helpPanel.name] || helpPanel.name}}</div>
        <i class="wms wms-clear"></i>
    </div>
    <div class="body">
        <p *ngIf="helpPanel.isPrefab && isWidgetProp">{{locale.LABEL_VERSION_CURRENT}}: {{widgetInfo.readableVersion ? widgetInfo.readableVersion+'('+widgetInfo.version+')':widgetInfo.version}}</p>
        <span *ngIf="helpPanel.isPrefab && isWidgetProp">{{locale.LABEL_DESCRIPTION}}:</span>
        <p [innerHTML]="helpPanel.info"></p>
    </div>
    <div class="footer" *ngIf="isWidgetProp">
        <a [href]="WIDGET_DOCS + helpPanel.widgetDocLink" *ngIf="!helpPanel.isPrefab" target="_blank">{{locale.USER_GUIDE}}</a> <br>
        <a [href]="appRef.apiDocsURL + '/' + helpPanel.apiDocLink" *ngIf="!helpPanel.isPrefab" target="_blank">{{locale.API_DOCS}}</a>
        <a *ngIf="helpPanel.isPrefab && widgetInfo.category === 'in-use' && widgetInfo.isPrefabInUse" title="{{locale.MESSAGE_DELETE_PREFAB}}" (click)="deletePrefabFromProject($event, widgetInfo)">{{locale.LABEL_DELETE}}</a>
    </div>
</div>

<wms-dialog id="deletePrefabFromProjectDialog" [content]="deletePrefabFromProjectContent" customClasses="delete-prefab-from-project-dialog small wm-studio-dialog"></wms-dialog>
<ng-template #deletePrefabFromProjectContent>
  <wms-delete-prefab-from-project [dialogParams]="dialogParams"></wms-delete-prefab-from-project>
</ng-template>
